import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import {
  ApprovalsCol,
  AuthorContentNameCol,
  CoauthorContentActionCol,
  ContentIdCol,
  ContentTypeCol,
  DisapprovalsCol,
  DraftStateCol,
  DraftVersionCol,
  IsTestDataCol,
  LastPublicationDateCol,
  PublicationStateCol,
  PublicationVersionCol,
  UpdatedDateCol,
  ProgressCol,
  ContentAudienceCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentTable from './ContentTable';

class SharedContentTable extends ContentTable {
  protected tableHeader = constants.SHARED_CONTENTS_HEADERS;
  protected tableId = WorkflowTableIdentity.SharedContent;
  protected columnDefinitions = [
    ContentIdCol,
    AuthorContentNameCol,
    ContentTypeCol,
    DraftStateCol,
    DraftVersionCol,
    PublicationStateCol,
    PublicationVersionCol,
    UpdatedDateCol,
    ApprovalsCol,
    DisapprovalsCol,
    LastPublicationDateCol,
    IsTestDataCol,
    ProgressCol,
    ContentAudienceCol,
    CoauthorContentActionCol,
  ];
  // Disable the table selection
  protected selectionType = '';

  protected fetchWorkflows = async () => {
    const { userProfile } = this.props;
    const res = await this.mplServiceClient.listSharedContentsForUser(userProfile.userId);
    return res.workflows;
  };

  protected validateUserRole = () => {
    return true;
  };
}

export default SharedContentTable;
